import { render } from "./KTDatatableBackend.vue?vue&type=template&id=466041fb&ts=true"
import script from "./KTDatatableBackend.vue?vue&type=script&lang=ts"
export * from "./KTDatatableBackend.vue?vue&type=script&lang=ts"

import "./KTDatatableBackend.vue?vue&type=style&index=0&id=466041fb&lang=scss"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__